import { render, staticRenderFns } from "./ShippingList.vue?vue&type=template&id=175017c4&scoped=true"
import script from "./ShippingList.vue?vue&type=script&lang=js"
export * from "./ShippingList.vue?vue&type=script&lang=js"
import style0 from "./ShippingList.vue?vue&type=style&index=0&id=175017c4&prod&scoped=true&lang=css"
import style1 from "./ShippingList.vue?vue&type=style&index=1&id=175017c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175017c4",
  null
  
)

export default component.exports